import Validation from '../lib/validation'

function validateHeader(data, type) {
  const validator = new Validation(data)
  switch (type) {
    case 'update': {
      validator.isRequired('_id', 'ID listiny je při editaci povinné.')
      validator.isObjectId('_id', 'ID listiny není ve správném formátu.')
    }
    // no default
  }
  validator.isRequired('company', 'Dopravce je povinný.')
  validator.isObjectId('company', 'ID dopravce není ve správném formátu.')
  
  validator.isRequired('location', 'Lokace je povinná.')
  validator.isObjectId('location', 'ID lokace není ve správném formátu.')
  
  validator.isRequired('courseType', 'Kurz je povinný.')
  
  validator.isRequired('date', 'Datum kurzu je povinný.')
  validator.isDate('date', 'Datum kurzu není ve správném formátu')
  
  return validator.validate()
}

function validateFiledata(data, type) {
  const validator = new Validation(data)
  validator.isRequired('_id', 'ID listiny je při editaci povinné.')
  validator.isObjectId('_id', 'ID listiny není ve správném formátu.')
  validator.isRequired('file_name', 'Soubor je povinný.')
  validator.isIntegerBiggerThan('file_size', 0, 'Soubor je prázdný.')
  return validator.validate()
}

export const validateCreate = (data) => validateHeader(data, 'create')
export const validateUpdate = (data) => validateHeader(data, 'update')
export const validateFile   = (data) => validateFiledata(data, 'update')

export default validateHeader



// WEBPACK FOOTER //
// ./src/common/attendances/validations.js